import { httpClient } from "api/httpClient";
import { useSocketContext } from "contexts/SocketProvider";
import { useEffect, useMemo } from "react";
import { usePermissions } from "react-admin";
import { isInArray } from "utils/general";

import { AppManagerRoles } from "../entities";
import { AppRoles, OsfcRoles, UserRole, orderCompaniesWorkers } from "../entities/";
import { SocketRooms } from "../entities/SocketRooms";
import { useNotifyError } from "../utils/notifiers/useNotifyError";

const draftOrderUserDataFetch = () => {
	httpClient(`init-user-data-draft-orders`, {
		method: "GET",
	})
	.catch((error) => {
		console.log(error);
	});
};

const deviationsUserDataFetch = () => {
	httpClient(`init-user-data-deviations`, {
		method: "GET",
	})
	.catch((error) => {
		console.log(error);
	});
};

export const useSocketLogic = () => {
	const notifyError = useNotifyError();
	const { permissions } = usePermissions();
	const {
		socket,
		error: socketError,
		joinRoom,
		isConnected,
		userSetupComplete,
	} = useSocketContext();

	const isSystemAdmin = useMemo(() => {
		if (!permissions) return false;
		return isInArray(AppManagerRoles, permissions.role);
	}, [permissions]);

	const isRoleForDeviations = useMemo(() => {
		if (!permissions) return false;
		const isAppRole = isInArray(AppRoles, permissions.role);
		const isOSFC = isInArray(OsfcRoles, permissions.role) || isAppRole;
		return isOSFC || orderCompaniesWorkers.has(permissions.role);
	}, [permissions]);

	useEffect(() => {
		if (isConnected && permissions) {
			const rooms = [socket.id, SocketRooms.common];
			if (isSystemAdmin) {
				rooms.push(SocketRooms.managers);
			}
			joinRoom(rooms);
		}
	}, [isConnected, socket?.id, joinRoom, permissions, isSystemAdmin]);

	useEffect(() => {
		if (socketError) {
			notifyError(socketError);
		}
	}, [socketError, notifyError]);

	useEffect(() => {
		if (userSetupComplete && permissions) {
			if (permissions.role !== UserRole.developer) {
				draftOrderUserDataFetch();
			}
			if (isRoleForDeviations) {
				deviationsUserDataFetch();
			}
		}
	}, [userSetupComplete, permissions, isRoleForDeviations]);

	return {};
};
